import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UiArguments } from "@recore-solutions/nstar-lib";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { CodeTableService } from "src/app/listing/code-table.service";
import { ListingService } from "./listing.service";
import { LoonFnFactoriesService } from "./loon-fn-factories.service";

@Injectable({ providedIn: "root" })
export class OfficeMemberFnFactoriesService extends LoonFnFactoriesService {
	constructor(
		protected listingService: ListingService,
		protected codeTableService?: CodeTableService
	) {
		super(listingService, codeTableService);
	}

	queryTransformFn = (uiArguments: UiArguments) => {
		const children = uiArguments.uiComponents.filter(
			(u) => u.parentApplicationUIComponentSK === uiArguments.uiComponent.applicationUIComponentSK
		);
		return (term, additionalParams) => {
			if (!!term && typeof term === "number") {
				return new HttpParams({
					fromObject: {
						[uiArguments.uiComponent.databaseTable + "." + uiArguments.uiComponent.databaseColumn]:
							(term as number).toString(),
					},
				});
			} else {
				if (
					!additionalParams?.every((a) => !!a) ||
					additionalParams?.every((a) => typeof a === "number")
				) {
					return null;
				}
				let httpParams = new HttpParams();
				httpParams = children.reduce(
					(a, c, i) =>
						a.set(
							c.databaseTable + "." + c.databaseColumn,
							additionalParams[i]?.key ? additionalParams[i].key : additionalParams[i]
						),
					httpParams
				);
				return httpParams;
			}
		};
	};

	searchFn = () => {
		return (httpParams: HttpParams) => {
			const currentOrNone = [];
			if (!httpParams) {
				return of(currentOrNone);
			}
			let httpParam$: Observable<HttpParams> = of(httpParams);
			if (httpParams.has("TeamMember.TeamMember_SK")) {
				const newHttpParams = httpParams
					.delete("TeamMember.TeamMember_SK")
					.set("OfficeMember.PrimaryOffice_IND", "Y")
					.set("OfficeMember.Expiration_UTCDTTM", "FUTURE");
				httpParam$ = this.listingService
					.getCodeTableValues("Roster", "TeamMember", httpParams)
					.pipe(
						map((teamMembers: { memberSK: number }[]) =>
							newHttpParams.set("Member.Member_SK", teamMembers?.[0]?.memberSK?.toString())
						)
					);
			}
			return httpParam$.pipe(
				switchMap((params) =>
					this.listingService.getCodeTableValues("Roster", "OfficeMember", params)
				),
				map((officeMembers) => (officeMembers || []).concat(currentOrNone))
			);
		};
	};
}
